import React, { useState } from 'react';
import { Space, Typography, DatePicker } from 'antd';
import { Button, Message } from '@alifd/next';
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/zh_TW';
import { downloadSheet } from './util';

export default function DownloadMonthlyReport() {
  const [months, setMonths] = useState([moment(), moment()]);

  const handleDownload = () => {
    if (months) {
      downloadSheet(
        `/ezcon/api/downloadFinancialMonthlyExcel?timeStart=${months[0].valueOf()}&timeEnd=${months[1].valueOf()}`,
        `${months[0].format('YYYYMM')}-${months[1].format('YYYYMM')}月報表.xlsx`
      );
    } else {
      Message.error('請選擇月份');
    }
  };

  return (
    <Space>
      <div>
        <Typography.Text>下載月份：</Typography.Text>
        <DatePicker.RangePicker
          picker="month"
          value={months}
          onChange={(value) => setMonths(value)}
          locale={locale}
          disabledDate={(current) => current && current > moment().endOf('day')}
        />
      </div>
      <Button onClick={handleDownload}>下載</Button>
    </Space>
  );
}
